import { render, staticRenderFns } from "./strategy_result_list.vue?vue&type=template&id=38c104a9"
import script from "./strategy_result_list.vue?vue&type=script&lang=js"
export * from "./strategy_result_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports